import {PropsWithChildren} from 'react'
import {SessionContext} from '../SessionContext'

export const SessionContextProvider = (props: PropsWithChildren) => {
    const setItem = (key: string, value: string): void => {
        sessionStorage.setItem(key, value)
    }

    const getItem = (key: string): string | null => {
        return sessionStorage.getItem(key)
    }

    return (
        <SessionContext.Provider
            value={{
                setItem,
                getItem,
            }}>
            {props.children}
        </SessionContext.Provider>
    )
}
